import Selector from "../../components/shared/Selector/Selector";
import BtButton from "../bt-button/bt-button";
import { ReactComponent as RefreshIcon } from "../../assets/svg/refreshIcon.svg";
import { FC } from "react";
import Loading from "../../components/shared/Loading";

type Props = {
  t: any;
  value: any,
  onChange: (value: any) => void,
  allNextProjects: any[];
  fetchAllNextProjects: () => void;
}

const NextProjectPlacementSelector : FC<Props> = ({ t, value, onChange, allNextProjects, fetchAllNextProjects }) => {
  return (
    <div style={{position: "relative", display:"flex", alignItems:"end", gap: "8px"}}>
      {allNextProjects.length == 0 && (
        <div style={{
          position: "absolute", width: "100%", height: "100%",
          backgroundColor: "rgba(255, 255, 255, 0.5)", top: 16, left: 0,
          mouseEvents: "none", zIndex: 1000,
          display: "flex", justifyContent: "center", alignItems: "center"
        }}>
          <Loading type="inline" size="24px" />
        </div>
      )}
      <Selector
        label={t('exportNextProjectModal.parentProjectLabel', 'Placering')}
        placeholder={t('exportNextProjectModal.selectParentProject', 'Välj överordnat projekt')}        
        options={allNextProjects.map(p => ({
          label: `${p.projectno} ${p.name}`,
          value: String(p.id),
        }))}
        value={value}
        onChange={onChange}
        className="add-project-field next-project-placement"
        isSearchable
        isClearable
      />
      <BtButton
        onClick={fetchAllNextProjects}
        color="white"
        class="next-project-refresh"
      >
        <RefreshIcon />
      </BtButton>
    </div>
  );
}

export default NextProjectPlacementSelector;